import insightQoreService from '../services/insightQoreService';
export const VOUCHER_BY_SALES = '@COMMISSIONVOUCHER/VOUCHER_BY_SALES';
export const VOUCHER_BY_SALES_CLEAR = '@COMMISSIONVOUCHER/VOUCHER_BY_SALES_CLEAR';
export const TIER_COMMISSION_SUMMARY =
  '@COMMISSIONVOUCHER/GET_COMM_TIER_COMMISSION_SUMMARY';
export const SELECTED_COMM_PERIOD = '@COMMISSIONVOUCHER/SELECTED_COMM_PERIOD';

export const VOUCHER_BY_SALES_PERIOD =
  '@COMMISSIONVOUCHER/GET_COMM_VOUCHER_BY_SALES_PERIOD';
export const SALES_TEAM = '@COMMISSIONVOUCHER/SALES_TEAM';
export const SALES_PERIODS = '@COMMISSIONVOUCHER/SALES_PERIODS';
export const SELECTED_SALES_TEAM_MEMBER =
  '@COMMISSIONVOUCHER/SELECTED_SALES_TEAM_MEMBER';
export const SELECTED_SALES_PERIOD = '@COMMISSIONVOUCHER/SELECTED_SALES_PERIOD';

export const MTR_SALES_SUMMARY = '@COMMISSIONVOUCHER/MTR_SALES_SUMMARY';
export const CLEAR_SALES_SUMMARY = '@COMMISSIONVOUCHER/CLEAR_SALES_SUMMARY';

export const MTR_NAVIGATATION_KEY_DATA =
  '@COMMISSIONVOUCHER/MTR_NAVIGATATION_KEY_DATA';
export const ASSOCIATED_MEMBERS = '@COMMISSIONVOUCHER/ASSOCIATED_MEMBERS';
export const CLEAR_COMM_VOUCHER_DATA = '@COMMISSIONVOUCHER/CLEAR_COMM_VOUCHER_DATA';

export const CLEAR_SALES_PERIODS = '@COMMISSIONVOUCHER/CLEAR_SALES_PERIODS';
export const TTM_VIEW = '@MTR/TTM_VIEW';

export const SHARED_SELECTED_REPORT_TYPE = '@MTR/SHARED_SELECTED_REPORT_TYPE';

export const SHARED_SALES_REP_CHANNEL = '@MTR/SHARED_SALES_REP_CHANNEL';

export const SHARED_SELECTED_SALES_MANAGER = '@MTR/SHARED_SELECTED_SALES_MANAGER';
export const SHARE_MANAGER_SELECTED_SALES_PERIOD = '@MTR/SHARE_MANAGER_SELECTED_SALES_PERIOD';

export function setMtrNavigationData(sourceData) {
  return async dispatch => {
    dispatch({
      type: MTR_NAVIGATATION_KEY_DATA,
      payload: { sourceData },
    });
  };
}

export function clearCommissionVouchersBySalesPeriod() {
  return async dispatch => {
    dispatch({
      type: VOUCHER_BY_SALES_CLEAR,
      payload: { salesData: [] },
    });
  };
}

export function getCommissionVouchersBySalesPerson(period, override = null, channel = null) {
  return async dispatch => {
    const { salesPerson, month, year } = period;
    let tiers = [];

    if (override) {
      tiers = await insightQoreService.getSalesAgentCommissionTiersById(override.parentSalesTeamId);
    }

    //JSON.stringify(override)
    const salesData = override ? await insightQoreService.getCommissionVouchersBySalesPerson(
      salesPerson,
      month,
      year,
      null,
      channel
    ) : await insightQoreService.getCommissionVouchersBySalesPerson(
      salesPerson,
      month,
      year,
      null,
      channel
    );

    dispatch({
      type: VOUCHER_BY_SALES,
      payload: { salesData, period, override, tiers },
    });
  };
}

export function getCommissionVouchersDataWithSalesPeriodsAndSalesMembers(
  view,
  teamMember,
  isBdeUser = false,
  associatedMembersFor = []
) {
  return async dispatch => {

    //get associated members for the selected team member
    if (associatedMembersFor && associatedMembersFor.length > 0) {
      //get and filter sales member / period
      teamMember = [].concat(associatedMembersFor
        .filter(item => { if (item.associatedRep) return item.associatedRep })
        .map(item => item.associatedRep));
    }

    let result = await insightQoreService.getCommissionVouchersDataWithSalesPeriodsAndSalesMembers(
      view,
      teamMember
    );

    let associates =
      (await insightQoreService.getSalesTeamAttributes()) || [];

    if (associates && associates.length === 0) {
      associates = []
    }
    let filterAssociated = [];
    let filteredAssociated = [];
    let bdeFilterAssociated = [];
    let bdeFilteredAssociated = [];
    let uniqueSalesRep = [];

    let salesReps = salesReps => {
      let unique_values = salesReps
        .filter(item => item.attributes.isEnabled)
        .map(item => item?.salesPerson)
        .filter(
          (value, index, current_value) => {
            return current_value.indexOf(value) === index
          }

        );
      return unique_values;
    };

    uniqueSalesRep = salesReps(result);


    //get associated members for the selected team member
    if (associatedMembersFor && associatedMembersFor.length > 0) {
      uniqueSalesRep = [];
      uniqueSalesRep = uniqueSalesRep.concat(associatedMembersFor
        .filter(item => { if (item.associatedRep) return item.associatedRep })
        .map(item => item.associatedRep));

    }

    if (associates && Array.isArray(associates)) {

      filterAssociated = associates
        ?.map(item => item)
        .filter(
          (value, index, current_value) =>
            value.repRoleCode === 'ASR' && value.isEnabled && view === 'CV'
        );

      filteredAssociated = filterAssociated
        ?.map(item => item.salesPersonName)
        .filter(
          (value, index, current_value) =>
            current_value.indexOf(value) === index
        );


      bdeFilterAssociated = associates
        ?.map(item => item)
        .filter(
          (value, index, current_value) =>
            value.repRoleCode === 'BDE' && value.isEnabled && view === 'MTR'
        );

      if (teamMember && isBdeUser) {
        const teamMemberAttributes = await insightQoreService.getSalesTeamMemeberAttributeByFullName(
          teamMember
        );
        if (teamMemberAttributes) {
          let associatedTeamMembers = await insightQoreService.getAssociatedTeamMemberById(
            teamMemberAttributes.salesTeamId
          );

          const filteredAssociated = associatedTeamMembers
            ?.map(item => item.salesPersonName)
            .filter(
              (value, index, current_value) =>
                current_value.indexOf(value) === index
            );

          bdeFilteredAssociated.push(teamMember);
          for (let index = 0; index < filteredAssociated.length; index++) {
            const element = filteredAssociated[index];
            bdeFilteredAssociated.push(element);
          }

          bdeFilteredAssociated.concat(filteredAssociated);

          //get and filter sales member / period
          result = await insightQoreService.getCommissionVouchersDataWithSalesPeriodsAndSalesMembers(
            view,
            null
          );

          uniqueSalesRep = [];
        }
      }
    }

    dispatch({
      type: VOUCHER_BY_SALES_PERIOD,
      payload: {
        salesCommissionData: result,
        uniqueSalesRep,
        filteredAssociated,
        bdeFilteredAssociated,
      },
    });
  };
}

export function getTieredCommissionSummary(salesPerson, atQuota, yoY) {
  return async dispatch => {
    const result = await insightQoreService.getGetTieredCommissionSummaryBySalesRep(
      salesPerson,
      atQuota,
      yoY
    );

    dispatch({
      type: TIER_COMMISSION_SUMMARY,
      payload: { ...result },
    });
  };
}

export function clearSalesSummaryData() {
  return async dispatch => {
    dispatch({
      type: CLEAR_SALES_SUMMARY,
      payload: { result: [], grossProfit80Data: [], grossProfit20Data: [] },
    });
  };
}
export function getGrossProfitData(salesPerson, month, year) {
  return async dispatch => {
    const result = await insightQoreService.getMtrRevenue(
      salesPerson,
      month,
      year
    );

    let grossProfit80Data = result?.detail
      ?.map(item => item)
      .filter((value, index, current_value) => value.isEighty === 1);

    let grossProfit20Data = result?.detail
      ?.map(item => item)
      .filter((value, index, current_value) => value.isEighty === 0);

    dispatch({
      type: MTR_SALES_SUMMARY,
      payload: { result, grossProfit80Data, grossProfit20Data },
    });
  };
}

export function setSelectedSalesTeamMember(selectedTeamMember) {
  return async dispatch => {
    dispatch({
      type: SELECTED_SALES_TEAM_MEMBER,
      payload: selectedTeamMember,
    });
  };
}

export function setSelectedPeriod(selectedPeriod) {
  localStorage.setItem('selectedSalesPeriod', JSON.stringify(selectedPeriod));
  return async dispatch => {
    dispatch({
      type: SELECTED_SALES_PERIOD,
      payload: selectedPeriod,
    });
  };
}

export function setSelectedReportType(selectedReportType) {
  return async dispatch => {
    dispatch({
      type: SHARED_SELECTED_REPORT_TYPE,
      payload: selectedReportType,
    });
  };
}

export function setSharedSalesChannelInfo(salesChannel) {
  return async dispatch => {
    dispatch({
      type: SHARED_SALES_REP_CHANNEL,
      payload: salesChannel,
    });
  };
}

export function setSelectedManager(selectedSalesManager) {

  return async dispatch => {
    dispatch({
      type: SHARED_SELECTED_SALES_MANAGER,
      payload: selectedSalesManager,
    });
  };
}

export function setManagerSelectedSalesPeriod(selectedSalesPeriod) {
  return async dispatch => {
    dispatch({
      type: SHARE_MANAGER_SELECTED_SALES_PERIOD,
      payload: selectedSalesPeriod,
    });
  };
}


export function setSalesPeriodList(salesPeriods) {

  return async dispatch => {
    dispatch({
      type: SALES_PERIODS,
      payload: salesPeriods,
    });
  };
}

export function clearSharedCommissionVoucherData() {
  return async dispatch => {
    dispatch({
      type: CLEAR_COMM_VOUCHER_DATA,
      payload: [],
    });
  };
}

export function getAssociatedMembers(userFullName, buildHierarchy = false) {
  return async dispatch => {
    const members = await insightQoreService.getAssociatedMembers(userFullName, buildHierarchy);

    dispatch({
      type: ASSOCIATED_MEMBERS,
      payload: { members },
    });
  };
}

export function setTTMView(value) {
  return async dispatch => {
    dispatch({
      type: TTM_VIEW,
      payload: value,
    });
  };
}
